import Fountain from "./main";
import { createCustomEvent } from "./event";

if (typeof(module.exports) !== 'undefined') {
    module.exports = Fountain;
}
(
    function () {
        // IE11-safe: createCustomEvent falls back when the constructor is missing,
        // so a legacy browser can't silently kill bootstrap before telemetry exists.
        // Wrapped because this runs at module load before any telemetry exists: if
        // the environment can't create/dispatch events at all, fail quietly rather
        // than throwing uncaught onto the host page (a third-party tag must not).
        try {
            window.dispatchEvent(createCustomEvent('Fountain.Init', {'class': Fountain}));
        } catch (error) {
            console.debug(error);
        }
    }
)();